export default __webpack_public_path__ + "static/media/feb2023-1.461da67d.jpg";